import {React,useEffect} from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/productherosection.css";
import AOS from "aos";
import "aos/dist/aos.css";
import HeroImage from "../assets/images/Hero Image/HeroImage.jpg"

const ProductHeroSection = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      easing: 'ease-out'
    });
  }, []);

  return (
    <section className="product-hero-section d-flex align-items-center text-white position-relative" id="home">
      
      {/* Background Image with Overlay */}
      <div className="hero-bg">
        <img
          src={HeroImage}
          alt="Hero Background"
          className="hero-img"
        />
        <div className="hero-overlay"></div>
      </div>

      {/* Content */}
      <div className="container position-relative text-center text-md-start" data-aos="fade-right" data-aos-delay="100">
        <div className="row">
          <div className="col-lg-8">
            <h1 className="display-5 fw-bold text-shadow">
              Discover Premium Air Conditioning & Ventilation Solutions
            </h1>
            <p className="fs-5 mb-4">
              Top-quality cooling and ventilation systems from industry-leading brands like Mitsubishi Electric, Blue Star, and Daikin.
            </p>

            {/* Buttons */}
            <div className="d-flex flex-wrap gap-3 justify-content-md-start justify-content-center" data-aos="fade-up" data-aos-delay="100">
              <a href="/services" className="btn btn-lg consultations-btn">
                Get Expert Consultation
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="scroll-indicator">
        <a href="#expertise">
          <div className="mouse">
            <div className="wheel"></div>
          </div>
          <div className="arrow">
            <span></span>
          </div>
        </a>
      </div>
    </section>
  );
};

export default ProductHeroSection;
